import React from "react";
import { defineMessages } from "react-intl";
import { useSelector } from "react-redux";
import { Button } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import { BulkModalContent } from "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import { BulkModalTitle } from "../../../components/modal/BulkModalTitle.js";
import "../../../components/modal/ModalButtons.js";
import { ModalFooter } from "../../../components/modal/ModalFooter.js";
import "@mui/material";
import "../../../components/modal/Modal.style.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import { useBulkActionResultValue, useAffectedRecords } from "../hooks.js";
import { actionsDataWithoutSkippedItemsSelector } from "../selectors.js";
import { BulkActionSummaryDetailsInfo } from "./BulkSummaryStepActionItem.js";
import { BulkSummaryStepActionLabel } from "./BulkSummaryStepActionLabel.js";
import { BulkTotalCountChip } from "./BulkTotalCountChip.js";
const localized = defineMessages({
  bulkStepChangesSummaryModalHeader: {
    id: "bulkStepChangesSummaryModalHeader",
    defaultMessage: "Applying Changes"
  },
  bulkStepChangesSummaryModalConfirm: {
    id: "bulkStepChangesSummaryModalConfirm",
    defaultMessage: "Confirm"
  },
  bulkStepChangesSummaryModalCancel: {
    id: "bulkStepChangesSummaryModalCancel",
    defaultMessage: "Cancel"
  }
});
function withBulkSummaryStepBase(WrappedDataGrid, columns, affectedEntityName, getGridProps) {
  return ({ onNext, onPrev, withFlexibleGrid }) => {
    const actionItems = useSelector(actionsDataWithoutSkippedItemsSelector);
    const resultValues = useBulkActionResultValue();
    const affectedRecordsForAllActions = useAffectedRecords();
    const handlePrevClick = () => {
      onPrev();
    };
    const handleNextClick = () => {
      onNext();
    };
    function renderGridRows(rows) {
      return /* @__PURE__ */ React.createElement(
        WrappedDataGrid,
        {
          ...getGridProps({
            rows,
            gridColumns: columns,
            withFlexibleGrid
          })
        }
      );
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkModalTitle, { title: localized.bulkStepChangesSummaryModalHeader }), /* @__PURE__ */ React.createElement(BulkModalContent, null, Object.keys(actionItems).map((actionKey) => {
      const affectedRecords = affectedRecordsForAllActions[actionKey] ?? [];
      return affectedRecords.length ? /* @__PURE__ */ React.createElement(
        BulkActionSummaryDetailsInfo,
        {
          key: `summaryDetails-${actionKey}`,
          expandable: true,
          actionKey,
          actionLabel: /* @__PURE__ */ React.createElement(
            BulkSummaryStepActionLabel,
            {
              actionKey: actionItems?.[actionKey]?.[0]?.actionKey,
              labelValue: actionItems?.[actionKey]?.[0]?.labelValue
            }
          ),
          actionValue: resultValues[actionKey],
          actionTotal: /* @__PURE__ */ React.createElement(
            BulkTotalCountChip,
            {
              totalItems: affectedRecords.length,
              affectedEntityName,
              chipType: "info"
            }
          )
        },
        renderGridRows(affectedRecords)
      ) : null;
    })), /* @__PURE__ */ React.createElement(ModalFooter, null, /* @__PURE__ */ React.createElement(Button, { label: localized.bulkStepChangesSummaryModalCancel, onClick: handlePrevClick }), /* @__PURE__ */ React.createElement(Button, { color: "primary", label: localized.bulkStepChangesSummaryModalConfirm, onClick: handleNextClick })));
  };
}
const withBulkSummaryStep = (WrappedDataGrid, columns, affectedEntityName) => withBulkSummaryStepBase(
  WrappedDataGrid,
  columns,
  affectedEntityName,
  ({ rows, gridColumns, withFlexibleGrid: isFlexible }) => ({
    rows,
    rawModels: rows?.map((i) => ({ isValid: true, raw: JSON.stringify(i) })),
    columns: gridColumns,
    rowsPerPageOptions: [100],
    hidePagination: rows.length < 100,
    autoHeight: true,
    isFlexible
  })
);
const withBulkSummaryStepGlide = (WrappedDataGrid, columns, affectedEntityName) => withBulkSummaryStepBase(
  WrappedDataGrid,
  columns,
  affectedEntityName,
  ({ rows, gridColumns, withFlexibleGrid: isFlexible }) => ({
    rows,
    rawModels: rows?.map((i) => ({ isValid: true, raw: JSON.stringify(i) })),
    columns: gridColumns,
    hidePagination: true,
    gridFullPage: false,
    maxVisibleRows: Math.min(10, rows?.length ?? 0),
    isFlexible
  })
);
export {
  withBulkSummaryStep,
  withBulkSummaryStepGlide
};
//# sourceMappingURL=BulkSummaryStepHoc.js.map
